export const ACCESS_TOKEN = 'access_token';
export const REFRESH_TOKEN = 'refresh_token';
export const USER_PROFILE = 'user_profile';
export const USER_NAME = 'userName';
export const REDIRECT_URL = 'redirect_url';
